import React, {FC, memo, useState} from "react";
import {Button, Modal} from "antd";
import {CloseOutlined} from "@ant-design/icons";
import {
    GetUnpaidScheduledPaymentsQuery,
    useGetAppSettingsQuery,
} from "../../../generated/graphql";
import useHighestRole from "../../../helpers/useHighestRole";
import Roles from "../../../../shared/models/roles";
import CreateDummyCamtFile from "./CreateDummyCamtFile";

type CreateDummyCamtFileModalProps = {
    openPayments?: GetUnpaidScheduledPaymentsQuery["unpaidScheduledPayments"]["items"];
};

const CreateDummyCamtFileModal: FC<CreateDummyCamtFileModalProps> = ({
    openPayments,
}) => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const highestRole = useHighestRole();
    const {
        data: appSettingData,
        loading: appSettingLoading,
    } = useGetAppSettingsQuery();

    const loading = appSettingLoading;

    if (appSettingData?.settings.esr === false) return null;

    if (highestRole !== Roles.Superuser) return null;

    return (
        <>
            <Modal
                title="Dummy Daten generieren"
                open={modalOpen}
                onCancel={() => setModalOpen(false)}
                destroyOnClose={true}
                width={1200}
                okButtonProps={{style: {display: "none"}}}
                cancelButtonProps={{
                    icon: <CloseOutlined />,
                }}
                cancelText="Ansicht schliessen"
            >
                <CreateDummyCamtFile
                    openPayments={openPayments}
                    setModalOpen={(open: boolean) => setModalOpen(open)}
                />
            </Modal>
            <Button
                loading={loading}
                danger
                size="small"
                style={{marginLeft: 7}}
                onClick={() => setModalOpen(!modalOpen)}
            >
                {"Dummy Daten generieren"}
            </Button>
        </>
    );
};

export default memo(CreateDummyCamtFileModal);
